module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_60y_n.6b401a71.csv";